import { COLOR_MAP } from "../constants/ColorNames";
import { placeholderMapping } from "../constants/helpers";
import { TabStatesProps } from "../types/dataTypes";
import { removeErrorSpan } from "./helpers";

export const tabStateAfterAddFUP = (tabState: TabStatesProps[]) => {
  const newTabStates = JSON.parse(JSON.stringify(tabState))
    const anyTabState = newTabStates[0];
    const newId = newTabStates.length;
    newTabStates.push({
      label: `Follow up-${newId}`,
      selectedFollowUPdays: '1',
      subject: '',
      email: '',
      applyButton: anyTabState?.applyButton,
      replyButton: anyTabState?.replyButton,
      stepNumber: newId + 1,
    })
    return newTabStates;
}

export const tabStateAfterFUPDelete = (tabState: TabStatesProps[], deletedTabLabel: string) => {
  const newTabStates = JSON.parse(JSON.stringify(tabState))
    const selectedTabIndex = newTabStates.findIndex((tab: TabStatesProps) => tab.label === deletedTabLabel)
    const selectedTabLabel = newTabStates[selectedTabIndex].label.split('-')[1]
    let count = 0;
    for (let i = selectedTabIndex + 1; i < newTabStates.length; i++) {
      newTabStates[i].label = `Follow up-${+selectedTabLabel + count}`
      count++
    }
    newTabStates.splice(selectedTabIndex, 1);
    return newTabStates;
}

export const updatedTabStateForRadioButtons = (tabState: TabStatesProps[],  value: string) => {
  const newTabStates = JSON.parse(JSON.stringify(tabState))
    // const selectedTabIndex = newTabStates.findIndex((tab: TabStatesProps) => tab.label === selectedTab);
    newTabStates.forEach((tab: TabStatesProps, index: number) => {
      if (value === 'apply') {
        newTabStates[index].applyButton = true;
        newTabStates[index].replyButton = false;
      }
      else if (value === 'reply') {
        newTabStates[index].replyButton = true;
        newTabStates[index].applyButton = false;
      }
      else {
        newTabStates[index].applyButton = true;
        newTabStates[index].replyButton = true;
      }
    });
    return newTabStates;
}

export const handleContentEditHelper = (tabState: TabStatesProps[], jobDescription: string, targetedValue: string,selectedTab: string, element: string) => {
  const newTabStates: TabStatesProps[] = JSON.parse(JSON.stringify(tabState))
  const selectedTabIndex = newTabStates.findIndex((tab: TabStatesProps) => tab.label === selectedTab);

  const profanityWordsInSelectedTab = newTabStates[selectedTabIndex].profanityWords;
  const profanityWordsInSubject = newTabStates[selectedTabIndex].profanityWordsInSubject;


  const isProfanityWordsPresentInEmail = profanityWordsInSelectedTab?.length && newTabStates[selectedTabIndex].showError;
  const isProfanityWordsPresentInSubject =  profanityWordsInSubject?.length && newTabStates[selectedTabIndex].showError;

  if (isProfanityWordsPresentInEmail ||  isProfanityWordsPresentInSubject ) {
    const isErrorPresentInEmail = element !== 'email' && element !== 'jd'? 
    profanityWordsInSelectedTab?.some((word) =>
      new RegExp(`\\b${word}\\b`, 'i').test(selectedTabIndex ? newTabStates[selectedTabIndex].email : newTabStates[0].email + jobDescription))

    : profanityWordsInSelectedTab?.some((word) =>
      new RegExp(`\\b${word}\\b`, 'i').test(targetedValue));

      const isErrorPresentInSubject = element !== 'subject' ? 
      profanityWordsInSubject?.some((word) =>
      new RegExp(`\\b${word}\\b`, 'i').test(newTabStates[selectedTabIndex].subject))
      :  
      profanityWordsInSubject?.some((word) =>
      new RegExp(`\\b${word}\\b`, 'i').test(targetedValue)); 
        if(element === 'subject'){
          targetedValue = removeErrorSpan(newTabStates[selectedTabIndex].subject, targetedValue);
        } else if(element === 'email') {
          targetedValue = removeErrorSpan(newTabStates[selectedTabIndex].email, targetedValue);
        }
        else{
          targetedValue = removeErrorSpan(jobDescription, targetedValue);
        }
  
    if (!isErrorPresentInEmail && !isErrorPresentInSubject) {
      newTabStates[selectedTabIndex].showError = false;
    }
  }

  return newTabStates;

}


export const updatedTabStateAfterPlaceholderInput = (tabState:TabStatesProps[], jobTitle: string, prevValue: string, value: string) => {
  const newTabStates: TabStatesProps[] = JSON.parse(JSON.stringify(tabState))
    
  newTabStates.forEach((item: TabStatesProps) => {
    item.email = prevValue 
        ? item.email.replaceAll(`${jobTitle}: ${prevValue}`, `${jobTitle}: ${value}`)
        : item.email.replaceAll(jobTitle, `${jobTitle}: ${value}`);
    item.subject = prevValue 
    ? item.subject.replaceAll(`${jobTitle}: ${prevValue}`, `${jobTitle}: ${value}`)
    : item.subject.replaceAll(jobTitle, `${jobTitle}: ${value}`);    
    
 
      const tempDivForEmail = document.createElement('div');
      const temDivForSubject = document.createElement('div');
      tempDivForEmail.innerHTML = item.email;
      temDivForSubject.innerHTML = item.subject;

      const svgElementArrayEmail = tempDivForEmail.querySelectorAll('span > div');
      const svgElementArraySub = temDivForSubject.querySelectorAll('span > div');
      svgElementArrayEmail.forEach(svgElement => {
        if (svgElement) {
          const spanWithSVG = svgElement.closest('div');
          // Get the inner text of the parent span
          const parent = spanWithSVG?.parentElement;
          if(parent?.innerText.trim().includes(jobTitle)){
            parent.style.borderColor = COLOR_MAP.GREEN
          }
        }
      })
      svgElementArraySub.forEach(svgElement => {
        if (svgElement) {
          const spanWithSVG = svgElement.closest('div');
          // Get the inner text of the parent span
          const parent = spanWithSVG?.parentElement;
          if(parent?.innerText.trim().includes(jobTitle)){
            parent.style.borderColor = COLOR_MAP.GREEN
          }
        }
      })
     
      item.email = tempDivForEmail.outerHTML;
      item.subject = temDivForSubject.outerHTML;
});

return newTabStates;
}